<script lang="ts" setup>
import { useClaims } from '@auth/useClaims';
import AppLayout from '@menu-lib/components/AppLayout/AppLayout.vue';
import VToast from '@shared/component/VToast/VToast.vue';

// voor het inladen van de app checken we of de gebruiker ingelogd is
// zodat deze direct ge-redirect kan worden naar het loginscherm
const claims = useClaims();
</script>
<template>
  <div v-if="claims?.isInitialLoading === false && claims?.isSuccess === true">
    <VToast />
    <AppLayout navigate-in-frame>
      <RouterView />
    </AppLayout>
  </div>
</template>

<style>
@import '@assets/styles/app.css';
</style>
